import {Component, inject, OnInit} from '@angular/core';
import {AuctionService} from '../../services/auction.service';
import {AuthService} from '../../services/auth.service';
import {MessageService} from 'primeng/api';
import {ActivatedRoute, Router} from '@angular/router';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-use-code-page',
  imports: [],
  template: ``
})
export class UseCodePageComponent implements OnInit {
  private auctionService = inject(AuctionService);
  private auth = inject(AuthService);
  private messages = inject(MessageService);
  private activatedRoute = inject(ActivatedRoute);
  private codeId!: string;
  private email!: string;
  private router: Router = inject(Router);

  async ngOnInit() {
    this.email = this.activatedRoute.snapshot.queryParams['email'];
    this.codeId = this.activatedRoute.snapshot.params['id'];
    await this.tryAddWithLoginFallback();
  }

  private async tryAddWithLoginFallback(): Promise<void> {
    try {
      const res = await firstValueFrom(this.auctionService.useCode(this.codeId));
      await this.router.navigate([''], {
        replaceUrl: true,
        state: {
          toast: {
            severity: 'success',
            summary: 'Dodawanie zakończone',
            detail: 'Kod został dodany.'
          }
        }
      });
    } catch (err: any) {
      if (err?.status === 403 || err?.status === 401) {
        const ok = await firstValueFrom(this.auth.openLoginDialog$(this.email));
        if (ok) {
          return this.tryAddWithLoginFallback();
        } else {
          this.messages.add({
            severity: 'warn',
            summary: 'Wymagane logowanie',
            detail: 'Zaloguj się, aby zaimportować kody.'
          });
        }
      } else {
        await this.router.navigate([''], {
          replaceUrl: true,
          state: {
            toast: {
              severity: 'error',
              summary: 'Błąd dodawania',
              detail: err?.error?.error || 'Spróbuj ponownie później.'
            }
          }
        });
        console.error('Import error:', err);
      }
    }
  }
}
